var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_871_10366)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.19995 10.8002C2.19995 6.05055 6.05031 2.2002 10.8 2.2002C15.5496 2.2002 19.4 6.05055 19.4 10.8002C19.4 13.1233 18.4788 15.2313 16.9819 16.7789C16.944 16.8072 16.9077 16.8386 16.8733 16.873C16.8389 16.9074 16.8075 16.9437 16.7791 16.9816C15.2316 18.4789 13.1234 19.4002 10.8 19.4002C6.05031 19.4002 2.19995 15.5499 2.19995 10.8002ZM17.5553 18.9692C15.7211 20.4876 13.3671 21.4002 10.8 21.4002C4.94574 21.4002 0.199951 16.6544 0.199951 10.8002C0.199951 4.94598 4.94574 0.200195 10.8 0.200195C16.6542 0.200195 21.4 4.94598 21.4 10.8002C21.4 13.3671 20.4876 15.7208 18.9694 17.5549L23.5075 22.093C23.8981 22.4835 23.8981 23.1167 23.5075 23.5072C23.117 23.8977 22.4839 23.8977 22.0933 23.5072L17.5553 18.9692Z",
    fill: "#363D49"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_871_10366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.7ebf5f9cbcac907d1b01d1d6aced2a9c.svg";
export { ForwardRef as ReactComponent };